import LayoutBody from "@/layout/layout-body";

export default [
  {
    path: "/voluntariado",
    component: LayoutBody,
    children: [
      {
        path: "",
        component: () => import("@/views/voluntariado/voluntariado"),
      },
      {
        path: "/voluntariado/actividades",
        component: () => import("@/views/voluntariado/voluntariado-actividades-carousel"),
      },
      {
        path: "/voluntariado/actividades/listar",
        component: () => import("@/views/voluntariado/actividades-listar"),
      },
      {
        path: "/voluntariado/coordinadores",
        component: () => import("@/views/voluntariado/voluntariado-coordinadores"),
      },
      {
        path: "/voluntariado/info",
        component: () => import("@/views/voluntariado/voluntariado-info"),
      },
      {
        path: "/voluntariado/escuela-observadores-democraticos",
        component: () => import("@/views/voluntariado/escuela-observadores-democraticos"),
      },
      {
        path: "/voluntariado/escuela-observadores-democraticos/modulos",
        component: () => import("@/views/voluntariado/modulos-eod"),
      },
      {
        path: "/voluntariado/escuela-observadores-democraticos/modulos/:id",
        component: () => import("@/views/voluntariado/modulo-eod-detail"),
      },
    ],
  }
];
